module.exports = __webpack_public_path__ + "static/media/tree-step-6_6.f1b6585d.svg";